'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/number-is-nan/index.js
// module id = 1098
// module chunks = 0 1 2 3 4 5 6 7